import React from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '700px',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  fields: {},
  informationContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  keyValuePair: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
});

function Layout({
  classes,
}) {
  const {
    resource,
  } = useMetaLayoutContext();
  const valuePair = (attr, color = 'mediumGray') => (
    <div className={classes.keyValuePair}>
      <Text variant={'h4'} color={'mediumGray'} text={`${resource?.meta().field(attr)?.attr('prompt')}:`} />
      <Text weight={'bold'} variant={'h4'} color={color} text={resource?.attr(attr)} />
    </div>
  );

  return (
    <div className={classes.root}>
      {resource?.attr('title')
        ? <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} /> : null}
      <div className={classes.informationContainer}>
        {valuePair('primaryOwnerRiskTolerance')}
        {valuePair('objective')}
        {valuePair('timeHorizon')}
        {valuePair('suggestedAllocationModel', 'secondary')}
        {valuePair('suggestedModelVariant', 'secondary')}
      </div>

      <MetaField attr={'isRetirementModel'} />
      <MetaField attr={'allocationModel'} />
      <MetaField attr={'associatedRothIra'} />
      <MetaField attr={'deviationJustificationMessage'} />
      <MetaField attr={'deviationJustification'} />
      <MetaField attr={'deviationJustificationAdditionalDetails'} />
      <MetaField attr={'isEsg'} />
      <MetaField attr={'modelAttribute'} />
      <MetaField attr={'alternativeIncomeAllocationPercentage'} />
      <MetaField attr={'retirementDeviationJustificationMessage'} />
      <MetaField attr={'retirementDeviationJustification'} />
      <MetaField attr={'retirementDeviationJustificationAdditionalDetails'} />
      <MetaField attr={'alternativeIncomeDeviationJustification'} />

      {
        resource?.attr('taxableAccountMessage')?.map(line => {
          return (
            <>
              <p />
              <Text variant={'h6'} color={'mediumGray'} text={line} />
            </>

          );
        })
      }


    </div>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
